export default "__VITE_ASSET__Bkpqbk4f__"